<template>
    <div>
        
    </div>
</template>
<script>

export default {
    name: 'MenuLateral',
    
}
</script>
